import React from 'react';

export type ValueTagType =
  | 'time-savings'
  | 'bid-confidence'
  | 'partner-id'
  | 'cost-savings'
  | 'new-opportunities';

interface ValueTagProps {
  type: ValueTagType;
  count: number;
}

const TAG_CONFIG: Record<ValueTagType, { label: string; icon: string; className: string }> = {
  'time-savings': {
    label: 'Time Savings',
    icon: '⏱',
    className: 'bg-teal-50 text-teal-700 border-teal-200',
  },
  'bid-confidence': {
    label: 'Bid Confidence',
    icon: '◎',
    className: 'bg-green-50 text-green-700 border-green-200',
  },
  'partner-id': {
    label: 'Partner ID',
    icon: '👤',
    className: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  'cost-savings': {
    label: 'Cost Savings',
    icon: '$',
    className: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  },
  'new-opportunities': {
    label: 'New Opp',
    icon: '◇',
    className: 'bg-red-50 text-red-700 border-red-200',
  },
};

export function ValueTag({ type, count }: ValueTagProps): React.ReactNode {
  const config = TAG_CONFIG[type];
  return (
    <span
      className={`inline-flex items-center gap-4 rounded-full border px-8 py-2 text-[1.1rem] font-medium ${config.className}`}
    >
      <span aria-hidden="true">{config.icon}</span>
      {config.label}
      {count > 1 && <span>&times;{count}</span>}
    </span>
  );
}
